import { BillingDetails } from '../../../shared/orders/payment';
import { CurrentUser } from '../../../shared/user/base';
import { PaymentGatewayConfig } from '../../APIClient';
import { TranslationKey } from '../../translations';

export const enum PaymentState {
  Pending = 0,
  Processing,
  Success,
  Failed,
  Declined,
  Cancelled,
}

export interface PaymentUpdate {
  state: PaymentState;
  message?: TranslationKey;
}

export interface PaymentProps {
  total: number;
  conventionName: string;
  user: CurrentUser;
  billingDetails: BillingDetails;
  paymentConfig: PaymentGatewayConfig;
  readonly onUpdate: (update: PaymentUpdate) => void;
}
